import { useEffect, useState } from "react";

import { subscribe } from "./sync";
import type { SyncSnapshot } from "./sync";

const EMPTY: SyncSnapshot = {
  state: "IDLE",
  online: true,
  entries: [],
  lastSyncedAt: null,
};

/** The queue, as React sees it. */
export function useOutbox(): SyncSnapshot {
  const [snapshot, setSnapshot] = useState<SyncSnapshot>(EMPTY);
  useEffect(() => subscribe(setSnapshot), []);
  return snapshot;
}
